import React, { useState, useEffect } from 'react';
import { getCurrentUser } from '../services/auth';
import api from '../services/api';

const VerificationBanner = () => {
  const [resending, setResending] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [user, setUser] = useState(getCurrentUser());

  // Check for both IsEmailVerified (C# PascalCase) and isEmailVerified (JavaScript camelCase)
  // Backend sends IsEmailVerified, but some serializers might convert to camelCase
  const isVerified = user?.IsEmailVerified === true || user?.isEmailVerified === true;

  // Listen for verification status changes
  useEffect(() => {
    const handleVerificationUpdate = () => {
      // Re-fetch user data from localStorage
      setUser(getCurrentUser());
    };

    // Listen for custom event
    window.addEventListener('userVerificationChanged', handleVerificationUpdate);

    return () => {
      window.removeEventListener('userVerificationChanged', handleVerificationUpdate);
    };
  }, []);

  const handleResend = async () => {
    setResending(true);
    try {
      await api.post('/Auth/resend-verification', { email: user.email });
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 5000); // Hide success message after 5 seconds
    } catch (error) {
      console.error('Failed to resend verification email:', error);
    } finally {
      setResending(false);
    }
  };

  // Don't show if user is verified or not logged in
  const shouldShow = user && !isVerified;

  return (
    <>
      {shouldShow && (
        <>
          {/* Fixed banner at top */}
          <div className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-400 dark:bg-yellow-600 border-b border-yellow-500 dark:border-yellow-700 shadow-md">
            <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
              <div className="flex items-center justify-center flex-wrap">
                <div className="flex items-center">
                  <span className="flex p-2 rounded-lg bg-yellow-500 dark:bg-yellow-700">
                    <svg className="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </span>
                  <div className="ml-3">
                    {showSuccess ? (
                      <p className="text-sm font-medium text-green-900 dark:text-green-100">
                        ✓ Verification email sent! Check your inbox and spam folder.
                      </p>
                    ) : (
                      <p className="text-sm font-medium text-gray-900 dark:text-white">
                        Please verify your email address to ensure full account access. Check your spam folder if you don't see it.{' '}
                        <button
                          onClick={handleResend}
                          disabled={resending}
                          className="font-semibold underline hover:text-gray-700 dark:hover:text-gray-200 disabled:opacity-50"
                        >
                          {resending ? 'Sending...' : "Didn't receive it? Resend"}
                        </button>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Spacer to push content down */}
          <div className="h-[52px]"></div>
        </>
      )}
    </>
  );
};

export default VerificationBanner;
